import { Button, Card, Typography } from '@mui/material';
import styles from './Information.module.scss'
import { useState } from 'react';

const Information = () => {
    const [activeButton, setActiveButton] = useState<string | null>(null);
    const handleButtonClick = (buttonName: string) => {
        setActiveButton(buttonName);
    };
    return (
        <>
            <div className={styles.totalLayout}>
                <Typography className={styles.typoGraphyHeading}>Pooja Item</Typography>
                <div style={{ marginTop: "20px" }}>
                    <Card className={styles.cardContainerList}>
                        <div className={styles.buttonContainer}>
                            <Button
                                className={activeButton === 'Individual Samskaras' ? styles.activeButton : ''}
                                onClick={() => handleButtonClick('Individual Samskaras')}
                            >Individual Samskaras</Button>
                            <Button>Weekly / MonthlyServices</Button>
                            <Button>Paid Sevas</Button>
                            <Button>AbhisekhaSponsorship</Button>
                        </div>
                    </Card>
                </div>
            </div>
        </>
    )
}
export default Information;